import React from 'react';
import styled from 'styled-components';

import locationIcon from '../../../assets/img/icons/location-2.svg';
import ComponentCircleLoader from '../../../components/Loaders/ComponentCircleLoader';
import CampContent from './CampContent';

// bg-white rounded-2xl shadow-sm overflow-hidden flex flex-col
// border: 1px solid rgb(229, 231, 235);
const CardContainer = styled.div`
  background-color: white;
  border-radius: 1rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e7eb;
`;

// px-5 py-3 flex items-center gap-2.5
// border-bottom: 1px solid #f3f4f6;
const CardHeader = styled.div`
  padding: 0.75rem 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  border-bottom: 1px solid #f3f4f6;
`;

// w-7 h-7 rounded-lg flex items-center justify-center
// background-color: rgb(243, 244, 246);
const LocationImageContainer = styled.div`
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f4f6;
`;

// font-size: 13px; font-weight: 600; color: #4f3423;
const SubTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #4f3423;
`;
// ml-auto text-[11px] px-2 py-0.5 rounded-full
// background-color: rgb(243, 244, 246); color: rgb(107, 114, 128);
const SubTitleBadge = styled.span`
  margin-left: auto;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 12px;
  background-color: #f3f4f6;
  color: #6b7280;
`;

// grid grid-cols-3 divide-x divide-gray-100 flex-1
const CommonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  > *:not(:last-child) {
    border-right: 1px solid #f3f4f6;
  }
`;

const CheckedInCard = ({ statusData, loading }) => {
  const COLOR_MAP = {
    Mina: '#1f2937',
    Arafat: '#d97706',
    Muzdalifah: '#3b82f6',
  };
  return (
    <CardContainer>
      <CardHeader>
        <LocationImageContainer>
          <img src={locationIcon} alt="Location Icon" />
        </LocationImageContainer>
        <SubTitle>Checked-in Camps</SubTitle>
        <SubTitleBadge>Offices</SubTitleBadge>
      </CardHeader>

      {loading ? (
        <ComponentCircleLoader padding="0" />
      ) : statusData?.length == 0 ? (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          No data available
        </div>
      ) : (
        <CommonGrid>
          {/* Card content goes here */}
          {statusData?.map(item => (
            <CampContent
              badge={'@' + item.public_zone_name}
              color={COLOR_MAP[item.public_zone_name]}
              total={item.total_offices}
              active={item.offices_clocked_in_today}
            />
          ))}
        </CommonGrid>
      )}
    </CardContainer>
  );
};

export default CheckedInCard;
